/**
 * reducers.js
 * Written by: Alex Kasemir
 */
import { combineReducers } from 'redux';

import { makePendingReducers } from '@minerva-analytics/pantheon';

export default combineReducers({
  ...makePendingReducers(),
});
